import { LOGOUT } from '../login/auth-reducer'
import { getJobs } from '../helpers/api'
import { db, pluckDocs } from '../helpers/db'
import { downloadCsv, formatAddress } from './utils'
import { addPage } from './pagination-reducer'
import { manifest } from '@fielded/forth-utils'
import { getCurrentPrice, findProduct } from './../products/utils'
import {sortByField} from '../helpers/utils'

const defaultState = {
  jobs: [],
  inMemoryJob: {},
  manifests: [],
  stockBalance: [],
  stockBalanceCSVRows: [],
  stockBalanceSheet: {},
  isJobsRequestOngoing: true
}

const REQUEST_JOBS = 'jobs/REQUEST_JOBS'
const RECEIVE_JOBS = 'jobs/RECEIVE_JOBS'
const RECEIVE_JOB = 'jobs/RECEIVE_JOB'
const RECEIVE_JOBS_FAILURE = 'jobs/RECEIVE_JOBS_FAILURE'
const SAVING_MANIFEST = 'jobs/SAVING_MANIFEST'

const REQUEST_JOBS_EXPORT = 'jobs/REQUEST_JOBS_EXPORT'
const RECEIVE_JOBS_EXPORT = 'jobs/RECEIVE_JOBS_EXPORT'
const RECEIVE_JOBS_EXPORT_FAILURE = 'jobs/RECEIVE_JOBS_EXPORT_FAILURE'
const RECEIVE_MANIFEST_UPDATE = 'jobs/RECEIVE_MANIFEST_UPDATE'
const RECEIVE_STOP_UPDATED_SUCCESSFUL = 'jobs/RECEIVE_STOP_UPDATE_SUCCESSFUL'
const RECEIVE_STOP_UPDATED_FAILURE = 'jobs/RECEIVE_STOP_UPDATE_FAILURE'
const RECEIVE_STOCK_BALANCE_UPDATE = 'jobs/RECEIVE_STOCK_BALANCE_UPDATE'
const RECEIVE_DISPENSED_UPDATE = 'jobs/RECEIVE_DISPENSED_UPDATE'
const RECEIVE_WAIT_REQUEST = 'jobs/RECEIVE_WAIT_REQUEST'
const RECEIVE_END_REQUEST = 'jobs/RECEIVE_END_REQUEST'
const RECEIVE_CSV_ROWS = 'jobs/RECEIVE_CSV_ROWS'
const RECEIVE_SHEET_ROWS = 'jobs/RECEIVE_SHEET_ROWS'

const SAVE_JOB_SUCCESS = 'jobs/SAVE_JOB_SUCCESS'
const SAVE_JOB_FAILURE = 'jobs/SAVE_JOB_FAILURE'
const UPDATE_INMEMORY_JOB = 'jobs/UPDATE_INMEMORY_JOB'
const CLEAR_INMEMORY_JOB = 'jobs/CLEAR_INMEMORY_JOB'
const CLEAR_SUCCESS_MESSAGE = 'jobs/CLEAR_SUCCESS_MESSAGE'
const JOB_REQUEST_ENDED = 'jobs/JOB_REQUEST_ENDED'
const UPDATE_JOBS = 'jobs/UPDATE_JOBS'
const ASSIGN_JOB_SUCCESS = 'jobs/ASSIGN_JOB_SUCCESS'

export default (state = defaultState, { type, ...actionParams }) => {
  switch (type) {
    case ASSIGN_JOB_SUCCESS:
      return {
        ...state,
        successMsg: 'Driver Assigned'
      }
    case SAVE_JOB_SUCCESS:
      return {
        ...state,
        successMsg: 'Job created successfully'
      }
    case CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        successMsg: ''
      }
    case SAVE_JOB_FAILURE:
      return {
        ...state,
        error: actionParams.error,
        successMsg: actionParams.error.reason
      }
    case UPDATE_JOBS:
      return {
        ...state,
        jobs: actionParams.jobs
      }
    case UPDATE_INMEMORY_JOB:
      return {
        ...state,
        inMemoryJob: { ...actionParams.data }
      }
    case CLEAR_INMEMORY_JOB:
      return {
        ...state,
        inMemoryJob: {}
      }
    case JOB_REQUEST_ENDED:
      return {
        ...state,
        isJobsRequestOngoing: false
      }

    case REQUEST_JOBS:
      return {
        ...state,
        isJobsRequestOngoing: true
      }
    case RECEIVE_JOBS:
      return {
        ...state,
        jobs: state.jobs.concat(actionParams.jobs),
        isJobsRequestOngoing: false,
        hasJobsRequestFailed: false
      }
    case RECEIVE_JOB:
      const jobs = state.jobs
      jobs.unshift(actionParams.job)
      return {
        ...state,
        jobs,
        isJobsRequestOngoing: false,
        hasJobsRequestFailed: false
      }
    case RECEIVE_JOBS_FAILURE:
      return {
        ...state,
        isJobsRequestOngoing: false,
        hasJobsRequestFailed: true
      }
    case REQUEST_JOBS_EXPORT:
      return {
        ...state,
        isExportRequestOngoing: true
      }
    case RECEIVE_JOBS_EXPORT:
      return {
        ...state,
        jobsExport: [].concat(actionParams.jobsExport),
        isExportRequestOngoing: false,
        hasExportRequestFailed: false
      }
    case RECEIVE_JOBS_EXPORT_FAILURE:
      return {
        ...state,
        isExportRequestOngoing: false,
        hasExportRequestFailed: true
      }
    case RECEIVE_MANIFEST_UPDATE:
      return {
        ...state,
        manifests: actionParams.data
      }
    case SAVING_MANIFEST:
      return {
        ...state,
        isManifestSaving: true
      }
    case RECEIVE_STOP_UPDATED_SUCCESSFUL:
      return {
        ...state,
        successMsg: 'Manifest saved successfully',
        isManifestSaving: false
      }
    case RECEIVE_STOP_UPDATED_FAILURE:
      return {
        ...state,
        error: actionParams.error,
        isManifestSaving: false
      }
    case RECEIVE_STOCK_BALANCE_UPDATE:
      return {
        ...state,
        stockBalance: actionParams.data
      }
    case RECEIVE_DISPENSED_UPDATE:
      return {
        ...state,
        dispensed: actionParams.data
      }
    case RECEIVE_WAIT_REQUEST:
      return {
        ...state,
        requestOngoing: true
      }
    case RECEIVE_END_REQUEST:
      return {
        ...state,
        requestOngoing: false
      }
    case RECEIVE_CSV_ROWS:
      return {
        ...state,
        stockBalanceCSVRows: actionParams.data
      }
    case RECEIVE_SHEET_ROWS:
      return {
        ...state,
        stockBalanceSheet: {...state.stockBalanceSheet, ...actionParams.data}
      }
    case LOGOUT:
      return {
        ...defaultState
      }
    default:
      return state
  }
}

/**
 * Reset InMemoryJob store
 */
export const resetInMemoryJob = () => (dispatch, getState) => {
  dispatch({
    type: CLEAR_INMEMORY_JOB
  })
}

/**
 * clear success message, just updating to ''
 */
export const clearSuccessMessage = () => (dispatch, getState) => {
  dispatch({
    type: CLEAR_SUCCESS_MESSAGE
  })
}

/**
 * this is used to update the in memory job, when creating job
 * @param patch updates any field with the patch object
 * @returns {undefined}
 */
export const updateInMemoryJob = patch => (dispatch, getState) => {
  const tempJob = getState().jobs.inMemoryJob
  dispatch({
    type: UPDATE_INMEMORY_JOB,
    data: { ...tempJob, ...patch }
  })
}

/**
 * Create assigment of job to driver doc
 * @param jobId
 * @param driverId
 * @param user
 */
const assignDriverDoc = (jobId, driverId, user) => ({
  eventType: 'assignment',
  type: 'event',
  createdAt: new Date().toISOString(),
  createdBy: user.name,
  data: {
    driverId: `driver:${driverId}`,
    jobId,
    status: 'assigned'
  },
  _id: 'event:assignment:' + jobId + ':timestamp:' + Date.now()
})

/**
 * @param jobs:Array
 * @param jobId
 * @param data
 *
 * this uses the jobId to go through the jobs and use the data passed to update the ones in there
 * @return jobs:array
 */
const updateJob = (jobs, jobId, data) => {
  const index = jobs.findIndex(job => job.job._id === jobId)
  jobs[index] = {
    ...jobs[index],
    ...data
  }

  return jobs
}

/**
 * This is used to assign a driver to a job
 *
 * @param jobId
 * @param driver
 */
export const assignJob = (jobId, driver) => (dispatch, getState) => {
  // show something is going on
  dispatch({
    type: REQUEST_JOBS
  })

  const job = getState().jobs.jobs.find(({job: {_id}}) => _id === jobId).job
  job.status = 'assigned'

  db
    .put(assignDriverDoc(jobId, driver._id, getState().auth.user))
    .then(res => {
      dispatch({
        type: UPDATE_JOBS,
        jobs: updateJob(getState().jobs.jobs, jobId, { job, driver })
      })
      dispatch({
        type: ASSIGN_JOB_SUCCESS
      })
      dispatch({
        type: JOB_REQUEST_ENDED
      })
    })
    .catch(e => {
      dispatch({
        type: RECEIVE_JOBS_FAILURE,
        error: e
      })
      dispatch({
        type: SAVE_JOB_FAILURE,
        error: e
      })
      dispatch({
        type: JOB_REQUEST_ENDED
      })
    })
}

/**
 * Generate note(manifest) for the Previous week balance passed
 * @param prevWeekBalance which is tied to a particular stop
 * @param products list of created products
 * returns string
 */
const prepareNewStopNote = (prevWeekBalance, products) => {
  const getOpeningQty = productName => {
    const openingQty = parseInt(prevWeekBalance.onHand.products[productName] || 0, 10) + parseInt(prevWeekBalance.dispensed.products[productName] || 0, 10)
    return openingQty
  }

  const getProductByName = name => findProduct(products, name) || {}

  return manifest.stringify(Object.keys(prevWeekBalance.dispensed.products).map(name => ({
    name,
    qty: 0,
    price: getCurrentPrice(getProductByName(name).prices).price,
    openingQty: getOpeningQty(name)
  })))
}

/**
 * This is used to create
 * - job
 * - stops
 */
export const saveJob = () => (dispatch, getState) => {
  const inMemoryJob = getState().jobs.inMemoryJob
  const products = getState().products.products

  // dispatch something is going on with the job
  dispatch({
    type: REQUEST_JOBS
  })

  const createdAt = new Date().toISOString()

  // let's create our job here
  const job = {
    createdAt,
    title: inMemoryJob.title,
    type: 'job',
    _id: 'job:' + inMemoryJob.title.replace(/ /g, '') + createdAt
  }

  // create stops and attach the job id to it
  let stops = inMemoryJob.stops.map(stop => {
    const transformedStop = {
      createdAt,
      type: 'stop',
      updatedAt: createdAt,
      address: {
        street: stop.street,
        state: stop.city,
        country: stop.country,
        city: stop.name
      },
      location: {
        latitude: stop.latitude,
        longitude: stop.longitude
      },
      pointOfDelivery: {
        name: stop.contactName,
        phone: stop.contactPhone
      },
      pickup: stop.pickup,
      _id: 'stop:' + stop.name + createdAt,
      jobId: job._id,
      clientId: stop.clientId
    }
    // Prefill with the last week's product
    const prevWeekBalance = getPrevWeekBalance(transformedStop)(dispatch, getState)
    transformedStop.lastVisit = prevWeekBalance.onHand.createdAt || createdAt
    transformedStop.note = prepareNewStopNote(prevWeekBalance, products)
    return transformedStop
  })

  db
    .bulkDocs([job, ...stops])
    .then(response => {
      job.status = 'unassigned'
      for (const resp of response) {
        if (job._id === resp.id) {
          job._rev = resp.rev
          continue
        }
        const stop = stops.find(stop => stop._id === resp.id)
        stop._rev = resp.rev
      }

      dispatch({
        type: RECEIVE_JOB,
        job: {
          job,
          stops,
          driver: {}
        }
      })
      dispatch({
        type: SAVE_JOB_SUCCESS
      })
      dispatch({
        type: CLEAR_INMEMORY_JOB
      })
      dispatch({
        type: JOB_REQUEST_ENDED
      })
    })
    .catch(e => {
      dispatch({
        type: RECEIVE_JOBS_FAILURE,
        error: e
      })
      dispatch({
        type: SAVE_JOB_FAILURE,
        error: e
      })
      dispatch({
        type: JOB_REQUEST_ENDED
      })
    })
}

export const findProductInManifest = (product, manifests = []) => {
  const index = manifests.findIndex(item => {
    if (!item.productId) {
      return (
        item.name.replace(/\s/, '').toLowerCase() ===
        product.name.replace(/\s/, '').toLowerCase()
      ) || (product.oldNames && product.oldNames.find(oldName => oldName.name === item.name))
    }
    return item.productId === product._id
  })

  return { index, item: manifests[index] }
}

export const fetchJobs = opts => (dispatch, getState) => {
  const handleJobs = jobs => {
    const prevJobs = getState().jobs.jobs
    const startkey = jobs[jobs.length - 1].job.createdAt
    dispatch(addPage(prevJobs, jobs, startkey))
    dispatch({ jobs, type: RECEIVE_JOBS })

    dispatch(fetchStockBalance(jobs))
  }

  dispatch({ type: REQUEST_JOBS })
  return getJobs(opts)
    .then(handleJobs)
    .catch(err => dispatch({ err, type: RECEIVE_JOBS_FAILURE }))
}

// no point calling the api since it's returning same result as fetchJob
// fetch export data based on the current job list pagination
export const fetchExport = () => (dispatch, getState) => {
  const download = jobsExport => {
    dispatch({ jobsExport, type: RECEIVE_JOBS_EXPORT })
    downloadCsv(jobsExport)
  }

  dispatch({ type: REQUEST_JOBS_EXPORT })

  const {currentPage, pages} = getState().pagination
  const page = pages[currentPage]
  const {jobs} = getState().jobs
  const paginatedJobs = jobs.slice(page.start, page.end)

  return Promise.resolve(paginatedJobs)
    .then(download)
    .catch(err => dispatch({ err, type: RECEIVE_JOBS_EXPORT_FAILURE }))
}

/**
   * this is used to get the onHand of last week for a
   *
   * go through all the stops and then use the name of the pharmacy to
   * get the most recent stops excluding the current one, and then use the
   * stopId and the jobId to get the onHand and Dispensed information
   * @param stop
   * @returns {dispensed:{*}, onHand:{*}}
   */
export const getPrevWeekBalance = stop => (dispatch, getState) => {
  const {jobs, stockBalance, dispensed} = getState().jobs
  // get all the stops in our system
  let allStops = jobs.reduce((allStops, job) => [...allStops, ...job.stops], [])

  // last stop for this pharmacy name not including this stop
  let lastStop = sortByField(allStops
    .filter(
      item =>
        item.address.city === stop.address.city &&
          item._id !== stop._id &&
          stop.createdAt > item.createdAt
    ), 'createdAt', 'DESC')

  const filter = item => {
    return item.stopId === lastStop[0]._id && item.jobId === lastStop[0].jobId
  }

  if (lastStop[0]) {
    // incase of multiple docs, use the most recent one fielded/van-orga#1982
    let lastDispensedQty = sortByField(dispensed.filter(filter), 'createdAt', 'DESC')
    let lastOnHandQty = sortByField(stockBalance.filter(filter), 'createdAt', 'DESC')
    return {
      dispensed: lastDispensedQty[0] || { products: {} },
      onHand: lastOnHandQty[0] || { products: {} }
    }
  }

  return { dispensed: { products: {} }, onHand: { products: {} } }
}

export const handleSaveManifestChangesToDB = stop => (dispatch, getState) => {
  const stopManifest = getState().jobs.manifests[stop._id]
  if (!stopManifest) {
    return
  }
  stop.note = manifest.stringify(stopManifest)

  dispatch({
    type: SAVING_MANIFEST
  })

  db
    .put(stop)
    .then(response => {
      stop._rev = response.rev // TODO: should replace this with couchdb change events update?
      dispatch({
        type: RECEIVE_STOP_UPDATED_SUCCESSFUL
      })
    })
    .catch(err => {
      dispatch({
        type: RECEIVE_STOP_UPDATED_FAILURE,
        error: err.message
      })
    })
}

export const loadManifest = (stopId, externalManifest) => (
  dispatch,
  getState
) => {
  const manifestInStore = { ...getState().jobs.manifests }
  const stopManifestInStore = manifestInStore[stopId] || []

  /**
   * guess here is the error, instead of concatenating,
   * just use the product name to merge both, giving the one in store more preference to override
   * the one coming from external, TBH: i don't know why doing this
   */
  manifestInStore[stopId] = externalManifest

  for (let storeManifest of stopManifestInStore) {
    let index = manifestInStore[stopId].findIndex(
      manifest => manifest.name === storeManifest.name
    )
    if (index > -1) {
      // if there before, use the one in store to update it
      manifestInStore[stopId][index] = storeManifest
    } else {
      // else just push it in
      manifestInStore[stopId][index].push(storeManifest)
    }
  }

  if (manifestInStore[stopId].length > 0) {
    dispatch({
      type: RECEIVE_MANIFEST_UPDATE,
      data: manifestInStore
    })
  }
}

export const handleToggleProductOnManifest = (stopId, product) => (
  dispatch,
  getState
) => {
  if (!stopId || stopId === '' || !product.name || product.name === '') {
    return
  }
  const allManifest = { ...getState().jobs.manifests }
  const stopManifest = allManifest[stopId] || []
  const productInManifest = findProductInManifest(product, stopManifest)

  if (productInManifest.index !== -1) {
    stopManifest.splice(productInManifest.index, 1)
  } else {
    stopManifest.push({ name: product.name, qty: '0', price: '0' })
  }

  allManifest[stopId] = stopManifest

  dispatch({
    type: RECEIVE_MANIFEST_UPDATE,
    data: allManifest
  })
}

// add/update item to manifest
export const upsertManifestItem = (stopId, product, index = -1, additionalProps = {}) => (dispatch, getState) => {
  const {jobs: {manifests}} = getState()
  // for locations with out manifest default to []
  const manifest = [...(manifests[stopId] || [])]

  // alert for duplicate product code errors
  const productInManifest = manifest.find(item => item.name === product.name)

  if (productInManifest) {
    window.alert(`Error product with code ${product.name} already exist, or contact support before pasting opening and pre-packed quantities`)
    return
  }

  const state = {
    name: product.name,
    qty: '0',
    ...additionalProps
  }

  if (manifest[index]) { // means updating
    manifest[index] = state
  } else {
  // means we want to add the new manifest item with the productId
    manifest.push(state)
  }

  manifests[stopId] = manifest

  dispatch({
    type: RECEIVE_MANIFEST_UPDATE,
    data: manifests
  })
}

// remove an index from stop manifest
export const removeManifestItem = (stopId, index) => (dispatch, getState) => {
  const allManifests = getState().jobs.manifests
  const manifest = [...allManifests[stopId]]

  manifest.splice(index, 1)
  allManifests[stopId] = manifest

  dispatch({
    type: RECEIVE_MANIFEST_UPDATE,
    data: allManifests
  })
}

export const updateManifestItem = (stopId, product, patch) => (
  dispatch,
  getState
) => {
  const allManifest = { ...getState().jobs.manifests }
  const stopManifest = allManifest[stopId] || []
  const productInManifest = findProductInManifest(product, stopManifest)

  if (productInManifest) {
    stopManifest[productInManifest.index] = {
      ...stopManifest[productInManifest.index],
      ...patch
    }
  }

  allManifest[stopId] = stopManifest

  dispatch({
    type: RECEIVE_MANIFEST_UPDATE,
    data: allManifest
  })
}

const getStockBalanceJob = (jobId, jobs) => {
  return jobs.find(job => jobId === job.job._id)
}

const getStockBalanceStop = (stopId, stops) => {
  return stops.find(stop => stopId === stop._id)
}

const addressStockBalance = (stockBalanceArr, jobs) => {
  return stockBalanceArr.reduce((formattedStockBalance, stockBalance) => {
    if (stockBalance.jobId && stockBalance.stopId) {
      const job = getStockBalanceJob(stockBalance.jobId, jobs)
      const stop = getStockBalanceStop(stockBalance.stopId, [...job.stops])

      if (stop) {
        formattedStockBalance.push({
          ...stockBalance,
          driver: job.driver.fullName,
          clientName: formatAddress(stop.address)
            .split(',')
            .join(' '),
          // TODO: this should be handled in the parser
          // the typeof will also be array once manifests as saved as standalone docs
          manifests: manifest.parse(stop.note || '')
        })
      }
    }

    return formattedStockBalance
  }, [])
}

const sortStockByJob = (dispensed, stockBalance, jobIds) => {
  const data = {}
  for (let id of jobIds) {
    const filter = doc => doc.jobId === id
    data[id] = {dispensed: dispensed.filter(filter), stockBalance: stockBalance.filter(filter)}
  }

  return data
}

/**
 * Get Sheet by the current pagination with the job and corresponding
 * dispensed and on hand balance
 * @return Array<{job, stockBalance, dispensed}
 */
export const getSheetByCurrentPage = () => (dispatch, getState) => {
  const {currentPage, pages} = getState().pagination
  const page = pages[currentPage]
  const {jobs, stockBalanceSheet} = getState().jobs
  const paginatedJobs = []

  // fastest method i think
  for (let i = page.start; i < page.end; i++) {
    paginatedJobs.push({job: jobs[i], ...stockBalanceSheet[jobs[i].job._id]})
  }
  return paginatedJobs
}

/**
 * TODO: split this to their respective reducers(onhand and dispensed), to reduce the tension on this file
 */
const getStockBalance = jobs => {
  const keys = jobs.map(job => job.job._id)
  const opts = {
    include_docs: true,
    keys
  }

  let stock = db
    .query('stock_balance/onhand-by-job', opts)
    .then(pluckDocs)
  let dispensed = db
    .query('stock_balance/dispensed-by-job', opts)
    .then(pluckDocs)

  return Promise.all([stock, dispensed]).then(values =>
    Promise.resolve({ stockDocs: values[0], dispensedDocs: values[1] })
  )
}

const fetchStockBalance = jobs => (dispatch, getState) => {
  dispatch({
    type: RECEIVE_WAIT_REQUEST
  })
  getStockBalance(jobs)
    .then(stockDispensedDocs =>
      Promise.all([
        addressStockBalance(stockDispensedDocs.stockDocs, jobs),
        stockDispensedDocs.dispensedDocs
      ])
    )
    .then(docs => {
      dispatch({
        type: RECEIVE_DISPENSED_UPDATE,
        data: docs[1]
      })
      dispatch({
        type: RECEIVE_STOCK_BALANCE_UPDATE,
        data: docs[0]
      })

      // sort stockbalance by job
      const sorted = sortStockByJob(docs[1], docs[0], jobs.map(job => job.job._id))
      dispatch({
        type: RECEIVE_SHEET_ROWS,
        data: sorted
      })

      dispatch({
        type: RECEIVE_END_REQUEST
      })
    })
    .catch(() => {
      dispatch({
        type: RECEIVE_END_REQUEST
      })
    })
}



// WEBPACK FOOTER //
// ./src/jobs/jobs-reducer.js